"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _shops = require("@module/shops");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _Header = _interopRequireDefault(require("./Header"));

var _Table = _interopRequireDefault(require("./Table"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function ShopsPage() {
  try {
    var handleToModeration = function handleToModeration(shopId) {
      dispatch((0, _shops.onModeration)(shopId));
    };

    var dispatch = (0, _reactRedux.useDispatch)();
    var items = (0, _reactRedux.useSelector)(_shops.selectItems);
    var shopsInProcess = (0, _reactRedux.useSelector)(_shops.selectShopsInProcess);
    return /*#__PURE__*/_react["default"].createElement("section", {
      className: "page"
    }, /*#__PURE__*/_react["default"].createElement("article", {
      className: "page__content",
      "data-locator": "Shops.content"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper'],
      "data-locator": "shops"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['header']
    }, /*#__PURE__*/_react["default"].createElement(_Header["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['content']
    }, /*#__PURE__*/_react["default"].createElement(_Table["default"], {
      items: items,
      shopsInProcess: shopsInProcess,
      onModeration: function onModeration(shopId) {
        return handleToModeration(shopId);
      }
    })))));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement("section", {
      className: "page"
    }, /*#__PURE__*/_react["default"].createElement("article", {
      className: "page__content",
      "data-locator": "Shops.content"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper'],
      "data-locator": "shops"
    }, /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    }))));
  }
}

var _default = ShopsPage;
exports["default"] = _default;